import { ApiError } from '@bala/core';
import { api } from './api';

/**
 * Ouvre l'application Parents avec la session Baygon déjà établie sur Staff.
 *
 * Échange le cookie Staff contre un jeton à usage unique, puis ouvre l'URL
 * SSO Parents. Nouvel onglet par défaut : l'administration Staff reste ouverte.
 */
export async function openParentsSso(target?: string): Promise<void> {
  const tab = typeof window !== 'undefined' ? window.open('about:blank', '_blank') : null;
  try {
    const res = await api.post<{ url: string }>('/auth/parents-sso', { target: target || '' });
    if (!res?.url) {
      throw new Error("Impossible d'ouvrir l'application Parents.");
    }
    if (tab && !tab.closed) {
      tab.location.href = res.url;
    } else {
      window.location.href = res.url;
    }
  } catch (error) {
    if (tab && !tab.closed) {
      tab.close();
    }
    if (error instanceof ApiError && error.status === 404) {
      throw new Error(
        "L'API n'a pas encore redémarré cette passerelle. Si le déploiement est récent, réessaie dans un instant.",
      );
    }
    throw error;
  }
}
